import axios from "../services/api/api";

export const FETCH_PROGRAMME_BEGIN = "FETCH_PROGRAMME_BEGIN";
export const FETCH_PROGRAMME_FULFILLED = "FETCH_PROGRAMME_FULFILLED";
export const FETCH_PROGRAMME_REJECTED = "FETCH_PROGRAMME_REJECTED";

export const FETCH_PROGRAMMES_BEGIN = "FETCH_PROGRAMMES_BEGIN";
export const FETCH_PROGRAMMES_FULFILLED = "FETCH_PROGRAMMES_FULFILLED";
export const FETCH_PROGRAMMES_REJECTED = "FETCH_PROGRAMMES_REJECTED";

export const FETCH_FORTNOX_PROGRAMS_BEGIN = "FETCH_FORTNOX_PROGRAMS_BEGIN";
export const FETCH_FORTNOX_PROGRAMS_FULFILLED =
  "FETCH_FORTNOX_PROGRAMS_FULFILLED";
export const FETCH_FORTNOX_PROGRAMS_REJECTED =
  "FETCH_FORTNOX_PROGRAMS_REJECTED";

export function fetchProgrammes(schoolId) {
  return dispatch => {
    dispatch({
      type: FETCH_PROGRAMMES_BEGIN,
      payload: { loading: true }
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get(`/programme/getBySchoolId/${schoolId}`)
          .then(response => {
            dispatch({
              type: FETCH_PROGRAMMES_FULFILLED,
              payload: response.data.result
            });
            resolve(true);
          })
          .catch(err => {
            dispatch({ type: FETCH_PROGRAMMES_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}

export function fetchProgramme(id) {
  return dispatch => {
    dispatch({
      type: FETCH_PROGRAMME_BEGIN,
      payload: { loading: true }
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get(`/programme/${id}`)
          .then(response => {
            dispatch({
              type: FETCH_PROGRAMME_FULFILLED,
              payload: response.data.result
            });
            resolve(true);
          })
          .catch(err => {
            dispatch({ type: FETCH_PROGRAMME_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}
export function fetchFortNoxPrograms() {
  return dispatch => {
    dispatch({
      type: FETCH_FORTNOX_PROGRAMS_BEGIN,
      payload: { loading: true }
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get(`/programme/FortNoxPrograms`)
          .then(response => {
            dispatch({
              type: FETCH_FORTNOX_PROGRAMS_FULFILLED,
              payload: response.data.result
            });
            resolve(true);
          })
          .catch(err => {
            dispatch({ type: FETCH_FORTNOX_PROGRAMS_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}
